import styled from 'styled-components';

export default styled.div`
  && {
    width: 100%;
    padding: 40px 65px;
    .spaceLine {
      margin-bottom: 32px;
    }
    .※ {
      color: rgba(255, 0, 0, 1);
      height: 18px;
      width: 12px;
      margin-right: 4px;
      margin-bottom: 32px;
    }
    .rec {
      width: 13px;
      height: 59px;
      background: #000000;
      border-radius: 10px 0 0 0;
      margin-right: 17px;
      margin-top: 5px;
    }
    .title {
      display: flex;
    }
    .textTitle {
      margin-top: 17px;
    }
    .form {
      padding: 53px 30px 40px 30px;
      margin-bottom: 20px;
      background-color: rgba(244, 244, 244, 1);
      .l {
        border-right: 0.5px solid #000000;
        height: 30px;
      }
      .l-disable {
        border-right: 0.5px solid rgba(204, 204, 204, 1);
        height: 30px;
      }
    }
    .form1 {
      padding: 30px 30px 5px 30px;
      background-color: rgba(244, 244, 244, 1);
      margin-bottom: 20px;
      .l {
        border-right: 1px solid #000000;
        height: 30px;
      }
      .space1 {
        margin: 5px;
        height: 14px;
      }
      .space2 {
        margin: 0 10px 0 15px;
      }
    }
    .pt-5 {
      padding-top: 5px;
    }
    .bb-1 {
      .ant-form-item {
        margin-bottom: 0;
      }
      :first-child {
        border: rgba(244, 244, 244, 1);
      }
      border-top: 1px solid #dddddd;
      padding-top: 6px;
    }
    .itemCenter {
      display: flex;
      align-items: center;
    }
    .disable {
      height: 30px;
      width: 100px;
      background-color: #dddddd;
    }
    .accessories-disable {
      font-family: Hiragino Kaku Gothic Pro;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 21px;
      color: #d8d8d8;
    }
    .accessories {
      display: flex;
      align-items: center;
      .space2 {
        margin: 0 10px;
      }
    }
    .mr-5 {
      margin-right: 5px;
    }
    .none {
      background-color: rgba(244, 244, 244, 1);
    }
    .mb-6px {
      margin-bottom: 6px;
    }
    .pl-10px {
      padding-left: 10px;
    }
    .m-5px {
      margin: 5px;
    }
    .form2 {
      padding: 30px;
      background-color: rgba(244, 244, 244, 1);
      margin-bottom: 20px;
      .l {
        border-right: 0.5px solid #000000;
        height: 30px;
        margin: 0 10px;
      }
    }
    .ant-form-item textarea {
      resize: none;
    }
    .mb-24 {
      margin-bottom: 24px;
    }
    .submit {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 30px;
      margin-bottom: 30px;
      .title {
        margin-bottom: 20px;
      }
      .text {
        text-align: center;
        margin-bottom: 20px;
      }
      .btn {
        width: 240px;
        height: 60px;
      }
    }
    .ml-15px {
      margin-left: 15px;
    }
    .disableModel {
      color: rgba(204, 204, 204, 1);
      .l {
        border-right: 1px solid rgba(204, 204, 204, 1);
      }
    }
    .back {
      margin-right: 10px;
      color: white;
      width: 112px;
      height: 60px;
      background: #c4c4c4;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      :hover {
        border: #c4c4c4;
      }
    }
    .ant-btn {
      :hover {
        background: white;
        border: 1px solid rgba(235, 164, 80, 1);
        color: rgba(235, 164, 80, 1);
      }
    }
  }
`;
